module.exports = __webpack_public_path__ + "static/media/test3.8255175a.png";